// src/components/Font.tsx
import React, { JSX } from "react";

type Family = "heebo" | "openSans" | "roboto" | "akaya";
type Element = keyof JSX.IntrinsicElements;

const FAMILY_VAR: Record<Family, string> = {
  heebo: "var(--font-heebo)",
  openSans: "var(--font-open-sans)",
  roboto: "var(--font-roboto)",
  akaya: "var(--font-akaya-kanadaka)",
};

export interface FontProps<E extends Element = "span">
  extends React.ComponentPropsWithoutRef<'span'> {
  family?: Family;
  /** use weights שהתקנת עם Fontsource:
   * Heebo: 400/600/900, Open Sans: 400/600, Roboto: 500, Akaya: 400
   */
  weight?: number;
  italic?: boolean;
  as?: E;
}

export function Font<E extends Element = "span">({
  family = "heebo",
  weight,
  italic,
  as,
  style,
  children,
  ...rest
}: FontProps<E>) {
  const Tag = (as || "span") as any;

  return (
    <Tag
      style={{
        fontFamily: FAMILY_VAR[family],
        fontWeight: weight,
        fontStyle: italic ? "italic" : undefined,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

/** אופציונלי: קומפוננטות נוחות לפי פונט */
export const Heebo: React.FC<Omit<FontProps, "family">> = (p) => (
  <Font family="heebo" {...p} />
);
export const OpenSans: React.FC<Omit<FontProps, "family">> = (p) => (
  <Font family="openSans" {...p} />
);
export const Roboto: React.FC<Omit<FontProps, "family">> = (p) => (
  <Font family="roboto" {...p} />
);
export const Akaya: React.FC<Omit<FontProps, "family">> = (p) => (
  <Font family="akaya" {...p} />
);
